export default function getLink(goal) {
  return goal.subtypeFocus
    ? `/goals/${goal.internalPerformanceMetric}/${goal.subtypeFocus}/actions`
    : `/goals/${goal.internalPerformanceMetric}/actions`;
}
